// Route publique "/invitation-organisateur/:token" : meme reconnaissance stricte que
// "/sorties/:token" (deux segments exactement, jeton de 32 caracteres base64url).
const INVITATION_TOKEN_PATTERN = /^[A-Za-z0-9_-]{32}$/;

export function matchOrganizerInvitationPath(pathname) {
  const segments = String(pathname || "").split("/").filter((segment) => segment.length > 0);
  if (segments.length !== 2 || segments[0] !== "invitation-organisateur") return null;
  return INVITATION_TOKEN_PATTERN.test(segments[1]) ? segments[1] : null;
}
